export const DateConstants = {
  DAILY: 'DAILY',
  WEEKLY: 'WEEKLY',
  BI_WEEKLY: 'BI_WEEKLY',
  MONTHLY: 'MONTHLY',
  YTD: 'YTD',
};

export const DateTabsData = [
  { label: 'Daily', value: DateConstants.DAILY },
  { label: 'Weekly', value: DateConstants.WEEKLY },
  // { label: "Bi-Weekly", value: DateConstants.BI_WEEKLY },
  { label: 'Monthly', value: DateConstants.MONTHLY },
  { label: 'YTD', value: DateConstants.YTD },
];
